export const updateUrl = (i18n) => {
  let params = new URLSearchParams(location.search)
  if (i18n.locale !== i18n.fallbackLocale) {
    params.set('lang', i18n.locale)
  } else {
    params.delete('lang')
  }
  if (params.toString().length) {
    params = '?'+params.toString()
  } else {
    params = ''
  }
  history.replaceState(null, "", location.href.split("?")[0]+params);
}